"use client";

import Layout from "@/components/Layout/Layout";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { ReactNode, useContext } from "react";
import { twMerge } from "tailwind-merge";
import { CMSModal } from "@/context";
import { useTranslation } from "react-i18next";

const EmployeeLayout = ({ children }: { children: ReactNode }) => {
  const { theme } = useContext(CMSModal);
  const pathname = usePathname();
  const { t } = useTranslation();

  const tabs = [
    { name: t("employees.tabs.timeline"), link: "/employees/timeline" },
    { name: t("employees.tabs.directory"), link: "/employees/directory" },
    { name: t("employees.tabs.department"), link: "/employees/department" },
    { name: t("employees.tabs.archive"), link: "/employees/archive" },
  ];

  return (
    <Layout>
      <div
        className={twMerge(
          "p-10 ",
          theme === "dark"
            ? "bg-[#262727] text-gray-100"
            : "bg-gray-100 text-[#3b3b3b]",
        )}
      >
        {" "}
        <div className="flex  overflow-x-auto scrollbar-hide md:flex-wrap md:overflow-x-visible">
          {tabs.map((tab) => {
            const isActive = pathname === tab.link;
            return (
              <Link
                key={tab.name}
                href={tab.link}
                className={twMerge(
                  "text-sm transition-colors relative cursor-pointer whitespace-nowrap w-52 flex items-center justify-center rounded-t-md shadow-t-sm",
                  isActive
                    ? twMerge(
                        "font-medium px-8 py-2",
                        theme === "dark"
                          ? "bg-[#262727] text-[#f74000]"
                          : "bg-white text-[#f74000]",
                      )
                    : twMerge(
                        "font-medium px-8 py-2",
                        theme === "dark"
                          ? "text-gray-400 hover:text-[#f74000] hover:bg-[#262727]"
                          : "text-gray-400 hover:text-[#f74000] hover:bg-gray-200",
                      ),
                )}
              >
                {tab.name}
              </Link>
            );
          })}
        </div>
        {children}
      </div>
    </Layout>
  );
};

export default EmployeeLayout;
